import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Col, Row } from "react-bootstrap";
import "./generate-report-modal.scss";
import ReportsService from "../../../../../../../../../services/reports-service";

const GenerateReportModal = ({ show, onClose, reports }) => {
    const reportsService = new ReportsService();

    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [alertModal, setAlertModal] = useState({ show: false, message: "" });

    const [formData, setFormData] = useState({
        addresseeTitle: "Mr.",
        firstName: "",
        middleInitial: "",
        lastName: "",
        designation: "",
        companyName: "",
        address: ""
    });

    useEffect(() => {
        // console.log("Reports:", reports);
    }, [reports]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedValue = name === "middleInitial" ? value.toUpperCase() : value;
        setFormData({ ...formData, [name]: updatedValue });
    };

    const handleSubmit = async () => {

        // Validate required fields (excluding middleInitial)
        const requiredFields = Object.entries(formData)
            .filter(([key]) => key !== "middleInitial");
        if (requiredFields.some(([, value]) => value.trim() === "")) {
            setAlertModal({ show: true, message: "All fields are required." });
            return;
        }

        const requestData = {
            bpId: reports[0].bpId,
            sellingAgentRequestDate: reports[0].sellingAgentRequestDate,
            addressee: [{
                addresseeTitle: formData.addresseeTitle,
                firstName: formData.firstName,
                middleInitial: formData.middleInitial,
                lastName: formData.lastName
            }],
            address: formData.address,
            companyName: formData.companyName,
            designation: formData.designation
        };

        try {
            const response = await reportsService.rrMakerGenerateCertificationOfHoldings(
                requestData.bpId,
                requestData.sellingAgentRequestDate,
                requestData.addressee,
                requestData.address,
                requestData.companyName,
                requestData.designation
            );

            // console.log(response);

            if (response.statusCode === 200) {
                onClose();
                setTimeout(() => setShowSuccessModal(true), 300);
            }
        } catch (error) {
            setAlertModal({ show: true, message: "Error submitting the report." });
        }
    };

    return (
        <>
            <Modal show={show} onHide={onClose} centered className="generate-report-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Generate Report</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* Note: Fields marked with * are required */}
                    <Form>
                        <Row className="mb-3 align-items-center">
                            <Col xs="auto">
                                <Form.Label className="mb-0">Addressee *</Form.Label>
                            </Col>
                            <Col xs="auto">
                                <Form.Group>
                                    <Form.Control
                                        as="select"
                                        name="addresseeTitle"
                                        size="sm"
                                        required
                                        className="mt-3 form-select"
                                        onChange={handleChange}
                                    >
                                        <option>Mr.</option>
                                        <option>Ms.</option>
                                        <option>Mrs.</option>
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col xs={5}>
                                <Form.Group className="pt-3">
                                    <Form.Control
                                        type="text"
                                        name="firstName"
                                        placeholder="Enter First Name *"
                                        maxLength={150}
                                        required
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col xs="auto">
                                <Form.Group className="pt-3">
                                    <Form.Control
                                        type="text"
                                        name="middleInitial"
                                        placeholder="M"
                                        maxLength={1}
                                        size="sm"
                                        className="middle-initial-input"
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-3 align-items-center">
                            <Col xs={{ span: 4, offset: 2 }}>
                                <Form.Group>
                                    <Form.Control
                                        type="text"
                                        name="lastName"
                                        placeholder="Enter Last Name *"
                                        maxLength={150}
                                        required
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group>
                            <Form.Label>Designation *</Form.Label>
                            <Form.Control
                                type="text"
                                name="designation"
                                placeholder="Enter Designation"
                                maxLength={150}
                                required
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Company *</Form.Label>
                            <Form.Control
                                type="text"
                                name="companyName"
                                placeholder="Enter Company Name"
                                maxLength={150}
                                required
                                onChange={handleChange}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>Address *</Form.Label>
                            <Form.Control
                                type="text"
                                name="address"
                                placeholder="Enter Address"
                                maxLength={150}
                                required
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>Close</Button>
                    <Button variant="primary" onClick={handleSubmit}>Confirm</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>Report is generating. Refresh in a few minutes!</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => window.location.reload()}>OK</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={alertModal.show} onHide={() => setAlertModal({ ...alertModal, show: false })} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Alert</Modal.Title>
                </Modal.Header>
                <Modal.Body>{alertModal.message}</Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={() => setAlertModal({ ...alertModal, show: false })}>OK</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default GenerateReportModal;
